import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import dayjs from "dayjs";
import _ from "lodash";
import { withRoute } from "util/withRoute";
import { Button } from "react-bootstrap";
import { DatePicker, Drawer, Input, Modal, Radio, Select } from "antd";

import {
  getActiveVenue,
  getActiveVenueId,
  getLeadClosedLostReasons,
  getLeadManageParentPath,
  getLeadManageStaticContent,
  getLeadStatusList,
  getPartnerAccount,
  getUserAgent,
} from "../../../App/AppReducer";
import {
  addVenuebundleNotesByVenuebundleId,
  addVisit,
  fetchLeadDetails,
  fetchLeadLogsByLeadId,
  fetchVenuebundleNotesByVenuebundleId,
  removeVenuebundleNotesByVenuebundleId,
  saveVenueNote,
  showFullViewTabVisibleState,
  updateLead,
  updateLeadStatusToClosedLost,
  updateLeadStatusToClosedWon,
  updateOtherLeadStatus,
  updateVenuebundleNotesByVenuebundleId,
} from "../../LeadManageActions";
import {
  getAddingVenueBundleNote,
  getEditingVenueBundleNote,
  getFullViewTabVisiblestate,
  getLeadDetails,
  getLeadLogId,
  getLeadLogs,
  getLeadUpdatingStatus,
  getSelectedLeadId,
  getVenueBundleNotes,
} from "../../LeadManageReducer";
import { userNotify } from "../../../../components/Toasts/ToastAdd";
import {
  fetchClosedLostReasonList,
  fetchLeadStatusList,
} from "../../../App/AppActions";
import {
  getLeadPageNum,
  getRejectingLeadStatus,
} from "../../../Lead/LeadReducer";
import RejectLeadForm from "../../components/RejectLeadForm";
import CloseWonLeadForm from "../../components/CloseWonLeadForm";
import { getPartnerAccountObjectMap } from "../../../Member/MemberReducer";
import { Helmet } from "react-helmet";
import PageAccessControl from "../../../../components/PermissionLocks/PageAccessControl";
import SwitchControl from "../../../../components/PermissionLocks/SwitchControl";
import {
  fetchLeadList,
  updateLastCallStatus,
  updateLeadStatus,
} from "modules/Lead/LeadActions";
import moment from "moment";
import { callingStatusList, visitStatusOption } from "constants/constants";

import styles from "./Basicdetailpage.module.css";

class BasicDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lead: {},
      venueNote: "",
      status: "",
      isShowRejectLeadForm: false,
      isShowClosedWonLeadForm: false,
      wonLeadId: "",
      rejectedLeadId: "",
      isNoteDrawerVisible: false,
      noteDrawerType: "Add Note",
      activeNote: {},
      notes: [],
      activeNoteIndex: "",
      isDeletingNote: false,
      venuebundlenotes: [],
      isEditingVenueBundleNote: false,
      editRawEventDate: false,
      followupDate: null,
      visitStatusDate: null,
      lastCallStatus: "",
      selectedVisitStatus: "",
      selectedVisitDate: null,
      visitStatus: "",
      appliedFilters: {
        datetype: "event_passed_at",
        pageNum: this.props.pageNum,
        pageSize: 25,
        sortBy: "",
        status: "",
        isFiltering: true,
        isSearching: false,
      },
    };
  }

  // ─── Lifecycle ───────────────────────────────────────────────────────────────

  componentDidMount() {
    const leadId = this.props?.leadid || this.props.params?.leadId;
    if (leadId) {
      this.props.dispatch(fetchLeadDetails(leadId));
      this.props.dispatch(fetchLeadLogsByLeadId(leadId));
    }
    if (_.isEmpty(this.state.lead)) {
      this.setState({ lead: this.props.lead });
    }
    this.props.dispatch(fetchLeadStatusList(leadId));
    this.props.dispatch(fetchClosedLostReasonList(leadId));
    this.props.dispatch(fetchVenuebundleNotesByVenuebundleId(leadId || "", {}));
    if (this.props.venuebundlenotes && !_.isEmpty(this.props.venuebundlenotes)) {
      this.setState({ venuebundlenotes: this.props.venuebundlenotes });
    }
  }

  componentDidUpdate(prevProps) {
    const leadId = this.props.leadid;
    if (!_.isEqual(leadId, prevProps.leadid)) {
      this.props.dispatch(fetchLeadDetails(leadId));
      this.props.dispatch(fetchVenuebundleNotesByVenuebundleId(leadId));
    }
    if (
      !_.isEqual(
        prevProps.venuebundlenotes?.length,
        this.props.venuebundlenotes?.length
      )
    ) {
      this.setState({ venuebundlenotes: this.props.venuebundlenotes });
    }
    if (!_.isEqual(prevProps.lead, this.props.lead)) {
      this.setState({ lead: this.props.lead });
    }
    if (!_.isEqual(prevProps.isEditingVenueBundleNote, this.props.isEditingVenueBundleNote)) {
      this.setState({
        isEditingVenueBundleNote: this.props.isEditingVenueBundleNote,
        venuebundlenotes: this.props.venuebundlenotes,
      });
    }
  }

  // ─── Status Handlers ─────────────────────────────────────────────────────────

  handleChangeStatus = (status) => {
    const newLead = { ...this.state.lead, status };
    this.setState({ lead: newLead }, () => {
      if (status && (this.props.leadid || this.props.params?.leadId)) {
        this.handleUpdateStatus(status);
      }
    });
  };

  handleUpdateStatus = (status) => {
    const lead = { status };
    const { agent, logId } = this.props;
    const leadId =
      this.state.lead._id || this.props.leadid || this.props.params?.leadId;
    this.setState({ lead: { ...this.state.lead, status } });
    if (status === "Closed - Won") {
      this.handleOpenWonLeadForm(leadId);
    } else if (status === "Closed - Lost") {
      this.handleOpenRejectLeadForm(leadId);
    } else {
      this.props.dispatch(updateOtherLeadStatus(leadId, lead, agent, logId));
    }
  };

  // ─── Field Handlers ───────────────────────────────────────────────────────────

  handleChange = (keyName, keyValue) => {
    this.setState({ editRawEventDate: false });
    const newLead = { ...this.state.lead, [keyName]: keyValue };
    this.setState({ lead: newLead });
  };

  handleFieldUpdate = (keyName, keyValue) => {
    const updatedLead = { ...this.state.lead, [keyName]: keyValue };
    this.setState({ lead: updatedLead, editRawEventDate: false }, () => {
      this.props.dispatch(
        updateLead(updatedLead._id, updatedLead, this.props.agent, this.props.logId)
      );
      this.props.dispatch(fetchLeadList(this.props.venueId, this.state.appliedFilters));
    });
  };

  handleLeadSave = () => {
    this.props.dispatch(
      updateLead(this.state.lead._id, this.state.lead, this.props.agent, this.props.logId)
    );
    this.props.dispatch(fetchLeadList(this.props.venueId, this.state.appliedFilters));
  };

  // ─── Visit Handlers ───────────────────────────────────────────────────────────

  handleChangeVisitDate = (date) => {
    this.setState({ visitStatusDate: date }, () => {
      this.saveEditVisitDate();
    });
  };

  saveEditVisitDate = () => {
    const { lead, visitStatusDate } = this.state;
    const visit = {
      visit_date: visitStatusDate,
      agentId: lead.admin_id,
      venueId: this.props.venueId,
      eventId: lead.event,
      venue_name: this.props.activeVenue?.name,
      isConfirmedByUser: true,
      isConfirmedByVenue: true,
      isCreatedByVenue: true,
      lead_source: "partner-crm",
      ref_id: this.props.leadid,
      ref_name: "venueBundle",
      isCreatedByAdmin: false,
    };
    this.props.dispatch(updateLeadStatus(lead._id, { ...lead, visit_status_date: visitStatusDate }));
    this.props.dispatch(addVisit(lead.event, this.props.venueId, visit));
  };

  handleSelectVisitStatus = (status) => {
    this.setState({ visitStatus: status.value }, () => {
      this.saveVisitStatus();
    });
  };

  saveVisitStatus = () => {
    const lead = { ...this.state.lead, visit_status: this.state.visitStatus };
    this.props.dispatch(updateLeadStatus(this.state.lead._id, lead));
  };

  // ─── Follow Up / Call Status Handlers ────────────────────────────────────────

  handleChangeDate = (date) => {
    this.setState({ followupDate: date }, () => {
      this.saveEditItem();
    });
  };

  saveEditItem = () => {
    const lead = { ...this.state.lead, active_follow_up_date: this.state.followupDate };
    this.props.dispatch(
      updateLastCallStatus(lead._id, lead, this.props.venueId, this.state.appliedFilters)
    );
  };

  handleChangeCallingStatus = (status) => {
    this.setState({ lastCallStatus: status?.value }, () => {
      this.saveCallStatus();
    });
  };

  saveCallStatus = () => {
    const lead = { ...this.state.lead, active_call_status: this.state.lastCallStatus };
    this.props.dispatch(
      updateLastCallStatus(lead._id, lead, this.props.venueId, this.state.appliedFilters)
    );
  };

  // ─── Notes Handlers ───────────────────────────────────────────────────────────

  handleDrawerToggle = () => {
    this.setState((prev) => ({ isNoteDrawerVisible: !prev.isNoteDrawerVisible }));
  };

  handleAddNote = (agent) => {
    if (!agent._id) {
      userNotify("No valid agent id provided", "error");
      this.handleDrawerToggle();
      return;
    }
    const note = {
      text: this.state.venueNote,
      partneraccount_id: agent._id,
      venuebundle_id: this.props.lead._id,
      venue_id: this.props.context?.activeVenue?._id,
      event_id: this.props.lead.event,
    };
    this.setState({ venueNote: "" });
    this.props.dispatch(addVenuebundleNotesByVenuebundleId(this.state.lead._id, note));
    this.handleDrawerToggle();
  };

  handleUpdateNote = (note_id) => {
    if (!note_id) {
      userNotify("No valid note id provided", "error");
      this.handleDrawerToggle();
      return;
    }
    const note = { ...this.state.activeNote, text: this.state.venueNote };
    const updatedNote = {
      venuebundlenote: {
        event_id: note.event_id,
        is_deleted: false,
        partneraccount_id: note.partneraccount_id,
        text: note.text,
        venue_id: note.venue_id,
        venuebundle_id: note.venuebundle_id,
        _id: note._id,
      },
    };
    this.props.dispatch(
      updateVenuebundleNotesByVenuebundleId(
        this.state.lead._id || this.props.lead._id || "",
        note._id || "",
        updatedNote
      )
    );
    this.setState({ venueNote: "" });
    this.handleDrawerToggle();
  };

  handleDeleteNote = () => {
    this.props.dispatch(
      removeVenuebundleNotesByVenuebundleId(
        this.props.lead._id || this.state.lead._id || "",
        this.state.activeNote._id || "",
        this.props.agent._id || ""
      )
    );
    this.setState({ isDeletingNote: false });
  };

  handleToggleDeleteModal = (note) => {
    this.setState((prev) => ({
      isDeletingNote: !prev.isDeletingNote,
      activeNote: note,
    }));
  };

  // ─── Reject / Won Handlers ────────────────────────────────────────────────────

  handleOpenRejectLeadForm = (leadId) => this.setState({ isShowRejectLeadForm: true, rejectedLeadId: leadId });
  handleCloseRejectLeadForm = () => this.setState({ isShowRejectLeadForm: false, rejectedLeadId: "" });

  handleOpenWonLeadForm = (leadId) => this.setState({ isShowClosedWonLeadForm: true, wonLeadId: leadId });
  handleCloseWonLeadForm = () => this.setState({ isShowClosedWonLeadForm: false, wonLeadId: "" });

  handleRejectAvailability = (leadId, lead) => {
    if (leadId) {
      this.props.dispatch(updateLeadStatusToClosedLost(leadId, lead, this.props.agent, this.props.logId));
      this.handleCloseRejectLeadForm();
      this.props.navigate("/lead/list");
    }
  };

  handleCloseWonEvent = (leadId, lead) => {
    if (leadId) {
      this.props.dispatch(updateLeadStatusToClosedWon(this.props.leadid, lead, this.props.agent, this.props.logId));
      this.handleCloseWonLeadForm();
    }
  };

  showMessage = (msg, msgtype) => userNotify(msg, msgtype);

  // ─── Render ───────────────────────────────────────────────────────────────────

  render() {
    const lead = this.state.lead;
    const staticContent = this.props.staticContent;
    const { TextArea } = Input;
    const breakpoint = 800;
    const isDesktop = this.props.windowWidth > breakpoint;

    const getInitials = (name = "") =>
      name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);

    return (
      <PageAccessControl
        shouldHavePermissions={["leads:read"]}
        userPermissions={this.props.partneraccount?.permissions || []}
      >
        <div className={styles.pageWrapper}>
          <Helmet>
            <title>Basic Details</title>
          </Helmet>

          {/* ── Add/Edit Note Drawer ── */}
          <Drawer
            placement={isDesktop ? "right" : "bottom"}
            width={"50%"}
            extra={
              <button
                className={styles.saveChangesBtn}
                onClick={() => {
                  if (!this.state.venueNote || this.state.venueNote.length === 0) {
                    userNotify("Please Write a note", "warning");
                  } else {
                    this.state.noteDrawerType === "Edit Note"
                      ? this.handleUpdateNote(this.state.activeNote._id || "")
                      : this.handleAddNote(this.props.agent || {});
                  }
                }}
              >
                {staticContent.BASIC_DETAIL_PAGE_SAVE_NOTE_TEXT}
              </button>
            }
            open={this.state.isNoteDrawerVisible}
            title={this.state.noteDrawerType}
            onClose={this.handleDrawerToggle}
          >
            <p style={{ marginBottom: "10px", color: "#9099b0", fontSize: "13px" }}>
              {this.state.noteDrawerType === "Edit Note"
                ? "Edit your note"
                : "Add a new note for everyone"}
            </p>
            <TextArea
              value={this.state.venueNote}
              onChange={(e) => this.setState({ venueNote: e.target.value })}
              style={{ minHeight: "200px", resize: "none", borderRadius: "8px" }}
              placeholder="Write your note here...."
            />
          </Drawer>

          {/* ── Delete Note Modal ── */}
          <Modal
            title="Delete a note"
            open={this.state.isDeletingNote}
            onOk={this.handleDeleteNote}
            onCancel={this.handleToggleDeleteModal}
          >
            <p>Are you sure you want to delete this note?</p>
          </Modal>

          {/* ── Top Bar: Visit Date / Visit Status / Follow-up / Call Status ── */}
           <div className={styles.topBar}>
 
            {/* Visit Date */}
            <div className={styles.topBarField}>
              <span className={styles.topBarLabel}>Visit Date</span>
              <div className={styles.editableField}>
                <DatePicker
                  className={styles.topBarInput}
                  onChange={(date) =>
                    this.handleChangeVisitDate(date ? date.toISOString() : null)
                  }
                  placeholder="dd-mm-yyyy"
                  disabledDate={(current) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return current && current.valueOf() < today.valueOf();
                  }}
                  value={
                    this.state.visitStatusDate
                      ? dayjs(this.state.visitStatusDate)
                      : lead?.visit_status_date
                      ? dayjs(lead.visit_status_date)
                      : null
                  }
                  showTime
                  format="DD MMM YYYY hh:mm a"
                  style={{ flex: 1 }}
                />
              </div>
            </div>
 
            {/* Visit Status */}
            <div className={styles.topBarField}>
              <span className={styles.topBarLabel}>Visit Status</span>
              <div className={styles.editableField}>
                <Select
                  style={{ flex: 1 }}
                  placeholder="Select"
                  labelInValue
                  onChange={this.handleSelectVisitStatus}
                  value={this.state.visitStatus || lead.visit_status}
                  options={visitStatusOption}
                />
              </div>
            </div>
 
            {/* Follow-up Date */}
            <div className={styles.topBarField}>
              <span className={styles.topBarLabel}>Follow-Up</span>
              <div className={styles.editableField}>
                <DatePicker
                  format="DD MMM YYYY"
                  placeholder="dd-mm-yyyy"
                  value={
                    this.state.followupDate
                      ? dayjs(this.state.followupDate)
                      : lead?.active_follow_up_date
                      ? dayjs(lead.active_follow_up_date)
                      : null
                  }
                  onChange={(date) =>
                    this.handleChangeDate(date ? date.toISOString() : null)
                  }
                  style={{ flex: 1 }}
                />
              </div>
            </div>

            {/* Call Status */}
            <div className={styles.topBarField}>
              <span className={styles.topBarLabel}>Call Status</span>
              <div className={styles.editableField}>
                <Select
                  style={{ flex: 1 }}
                  placeholder="Select"
                  labelInValue
                  onChange={this.handleChangeCallingStatus}
                  value={this.state.lastCallStatus || lead.active_call_status}
                  options={callingStatusList}
                />
              </div>
            </div>
          </div>

          {/* ── Cards Grid ── */}
          <div className={styles.cardsGrid}>

            {/* ── Customer Details Card ── */}
            <div className={`${styles.card} ${styles.cardCustomer}`}>
              <div className={styles.cardHeader}>
                <span className={styles.cardTitle}>Customer</span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Name
                  </span>
                  <span className={styles.rowValue}>{lead.contact_name || "--"}</span>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Mobile
                  </span>
                  <span className={styles.rowValue}>
                    <a href={`tel:${lead.contact_phone}`} className={styles.phoneLink}>
                      {lead.contact_phone}
                    </a>
                  </span>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Email
                  </span>
                  <span className={styles.rowValue}>{lead.contact_email || "--"}</span>
                </div>
              </div>
            </div>

            {/* ── Event Details Card ── */}
            <div className={`${styles.card} ${styles.cardEvent}`}>
              <div className={styles.cardHeader}>
                <span className={styles.cardTitle}>
                  {staticContent.BASIC_DETAIL_PAGE_EVENT_TITLE || "Event Details"}
                </span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>{staticContent.BASIC_DETAIL_PAGE_OCCASION_TEXT}</span>
                  <span className={styles.rowValue}>{lead.occasion || lead.category || "--"}</span>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>Event</span>
                  <div>
                    <SwitchControl
                      shouldHavePermissions={["leads:edit"]}
                      userPermissions={this.props.partneraccount?.permissions || []}
                      yes={
                        <DatePicker
                          format="DD MMM YYYY"
                          value={lead.event_date ? dayjs(lead.event_date) : null}
                          onChange={(date) =>
                            date && this.handleFieldUpdate("event_date", date.toISOString())
                          }
                          className={styles.editInput}
                        />
                      }
                      no={
                        <span className={styles.rowValue}>
                          {lead.event_date ? dayjs(lead.event_date).format("DD MMM YYYY") : lead.raw_event_date || "--"}
                        </span>
                      }
                    />
                  </div>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>{staticContent.BASIC_DETAIL_PAGE_GUEST_TEXT}</span>
                  <SwitchControl
                    shouldHavePermissions={["leads:edit"]}
                    userPermissions={this.props.partneraccount?.permissions || []}
                    yes={
                      <input
                        className={styles.editInput}
                        type="number"
                        min={0}
                        value={lead.guests || 0}
                        onChange={(e) => this.handleChange("guests", parseInt(e.target.value))}
                        onBlur={() => this.handleFieldUpdate("guests", this.state.lead.guests)}
                        style={{ width: "150px", textAlign: "right" }}
                      />
                    }
                    no={
                      <span className={styles.rowValue}>
                        {lead.guests || "--"}
                      </span>
                    }
                  />
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>{staticContent.BASIC_DETAIL_PAGE_BUDGET_TEXT}</span>
                  <SwitchControl
                    shouldHavePermissions={["leads:edit"]}
                    userPermissions={this.props.partneraccount?.permissions || []}
                    yes={
                      <span style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                        <input
                          className={styles.editInput}
                          type="number"
                          min={0}
                          value={lead.budget_start || 0}
                          onChange={(e) => this.handleChange("budget_start", e.target.value)}
                          onBlur={() => this.handleFieldUpdate("budget_start", this.state.lead.budget_start)}
                          style={{ width: "65px", textAlign: "right" }}
                        />
                        <span style={{ color: "#9099b0" }}>–</span>
                        <input
                          className={styles.editInput}
                          type="number"
                          min={0}
                          value={lead.budget_end || 0}
                          onChange={(e) => this.handleChange("budget_end", e.target.value)}
                          onBlur={() => this.handleFieldUpdate("budget_end", this.state.lead.budget_end)}
                          style={{ width: "65px", textAlign: "right" }}
                        />
                      </span>
                    }
                    no={
                      <span className={styles.budgetValue}>
                        ₹{lead.budget_start?.toLocaleString("en-IN")}–{lead.budget_end?.toLocaleString("en-IN")}
                      </span>
                    }
                  />
                </div>
              </div>
            </div>

            {/* ── Lead Temperature Card ── */}
            <div className={`${styles.card} ${styles.cardTemperature}`}>
              <div className={styles.cardHeader}>
                <span className={styles.cardTitle}>Lead Temperature</span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.temperatureWrapper}>
                  <SwitchControl
                    shouldHavePermissions={["leads:edit"]}
                    userPermissions={this.props.partneraccount?.permissions || []}
                    yes={
                      <>
                        <button
                          className={`${styles.tempBtn} ${styles.tempBtnCold} ${lead.prospect === "Cold" ? styles.active : ""}`}
                          onClick={() => this.handleFieldUpdate("prospect", "Cold")}
                          type="button"
                        >
                          ❄ Cold
                        </button>
                        <button
                          className={`${styles.tempBtn} ${styles.tempBtnWarm} ${lead.prospect === "Warm" ? styles.active : ""}`}
                          onClick={() => this.handleFieldUpdate("prospect", "Warm")}
                          type="button"
                        >
                          🌤 Warm
                        </button>
                        <button
                          className={`${styles.tempBtn} ${styles.tempBtnHot} ${lead.prospect === "Hot" ? styles.active : ""}`}
                          onClick={() => this.handleFieldUpdate("prospect", "Hot")}
                          type="button"
                        >
                          🔥 Hot
                        </button>
                      </>
                    }
                    no={
                      <>
                        <button disabled className={`${styles.tempBtn} ${styles.tempBtnCold}`}>❄ Cold</button>
                        <button disabled className={`${styles.tempBtn} ${styles.tempBtnWarm}`}>🌤 Warm</button>
                        <button disabled className={`${styles.tempBtn} ${styles.tempBtnHot}`}>🔥 Hot</button>
                      </>
                    }
                  />
                </div>
              </div>
            </div>

            {/* ── Agent Information Card (full width) ── */}
            <div className={`${styles.card} ${styles.cardAgent}`}>
              <div className={styles.cardHeader}>
                <span className={styles.cardTitle}>
                  {staticContent.BASIC_DETAIL_PAGE_ADMIN_TEXT || "Agent"}
                </span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Name
                  </span>
                  <span className={styles.rowValue}>{lead.admin_name || "--"}</span>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Mobile
                  </span>
                  <span className={styles.rowValue}>{lead.admin_phone || "--"}</span>
                </div>
                <div className={styles.row}>
                  <span className={styles.rowLabel}>
                    Email
                  </span>
                  <span className={styles.rowValue}>{lead.admin_email || "--"}</span>
                </div>
              </div>
            </div>

            {/* ── Notes Card (Full Width) ── */}
            <div className={`${styles.card} ${styles.cardNotes}`}>
              <div className={styles.notesHeader}>
                <button className={styles.activeNotesBtn}>
                  {staticContent.BASIC_DETAIL_PAGE_ACTIVE_NOTE_TEXT}
                </button>
                <SwitchControl
                  shouldHavePermissions={["leads:edit"]}
                  userPermissions={this.props.partneraccount?.permissions || []}
                  yes={
                    <button
                      className={styles.addNoteBtn}
                      onClick={() => {
                        this.setState({ noteDrawerType: "Add Note", venueNote: "" });
                        this.handleDrawerToggle();
                      }}
                    >
                      + {staticContent.BASIC_DETAIL_PAGE_ADD_NOTE_TEXT}
                    </button>
                  }
                  no={
                    <button disabled className={styles.addNoteBtn} style={{ opacity: 0.5 }}>
                      + {staticContent.BASIC_DETAIL_PAGE_ADD_NOTE_TEXT}
                    </button>
                  }
                />
              </div>
              <div
                className={styles.cardBody}
                style={{ maxHeight: isDesktop ? "50vh" : "40vh", overflowY: "auto" }}
              >
                {this.state.venuebundlenotes?.length > 0 ? (
                  this.state.venuebundlenotes.map((note) => {
                    const accountInfo =
                      this.props.partnerAccountObjectMap?.[note.partneraccount_id];
                    const authorName = accountInfo
                      ? `${accountInfo.first_name || ""} ${accountInfo.last_name || ""}`.trim()
                      : "--";
                    const initials = getInitials(authorName);
                    const isOwn = note.partneraccount_id === this.props.agent?._id;
                    return (
                      <div key={note._id} className={styles.noteItem}>
                        <div className={styles.noteAuthorRow}>
                          <div className={styles.noteAvatar}>{initials}</div>
                          <span className={styles.noteAuthorName}>{authorName}</span>
                          <span className={styles.noteTimestamp}>
                            {note.updated_at && !dayjs(note.updated_at).isSame(note.created_at)
                              ? dayjs(note.updated_at).format("DD MMM YYYY, hh:mm a") + " · Edited"
                              : dayjs(note.created_at).format("DD MMM YYYY, hh:mm a")}
                          </span>
                          {isOwn && (
                            <span style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
                              <button
                                className={styles.addNoteBtn}
                                style={{ padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => this.handleToggleDeleteModal(note)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                              <button
                                className={styles.addNoteBtn}
                                style={{ padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => {
                                  this.setState({
                                    noteDrawerType: "Edit Note",
                                    activeNote: note,
                                    venueNote: note.text,
                                  });
                                  this.handleDrawerToggle();
                                }}
                              >
                                <i className="fa fa-pencil" />
                              </button>
                            </span>
                          )}
                        </div>
                        <div className={styles.noteText}>{note.text}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className={styles.emptyState}>You don't have any notes yet</div>
                )}
              </div>
            </div>
          </div>

          {/* ── Reject Lead Drawer ── */}
          {this.state.isShowRejectLeadForm && (
            <Drawer
              open={this.state.isShowRejectLeadForm}
              onClose={this.handleCloseRejectLeadForm}
              width={window.innerWidth > 768 ? 500 : undefined}
              placement={window.innerWidth > 768 ? 'right' : 'bottom'}
              height={window.innerWidth > 768 ? undefined : 'auto'}
              bodyStyle={window.innerWidth > 768 ? undefined : { padding: '15px', overflowY: 'auto' }}
              styles={{
                content: {
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                  overflow: 'hidden'
                }
              }}
            >
              <RejectLeadForm
                leadId={this.state.rejectedLeadId}
                closedLostReasons={this.props.closedLostReasons}
                showMessage={this.showMessage}
                isRejectingLead={this.props.isRejectingLead}
                handleRejectAvailability={this.handleRejectAvailability}
                venueId={this.props.venueId}
              />
            </Drawer>
          )}

          {/* ── Closed Won Drawer ── */}
          {this.state.isShowClosedWonLeadForm && (
            <Drawer
              open={this.state.isShowClosedWonLeadForm}
              onClose={this.handleCloseWonLeadForm}
              title="Closed Won Lead Form"
              width={500}
            >
              <CloseWonLeadForm
                leadId={this.state.wonLeadId}
                closedWonReasons={[]}
                showMessage={this.showMessage}
                isRejectingLead={this.props.isRejectingLead}
                handleCloseWonEvent={this.handleCloseWonEvent}
                leadid={this.state.lead.venue}
              />
            </Drawer>
          )}
        </div>
      </PageAccessControl>
    );
  }
}

// ─── Redux ────────────────────────────────────────────────────────────────────

function mapStateToProps(state, props) {
  return {
    venueId: getActiveVenueId(state),
    leadId: props.params?.leadId,
    leadid: getSelectedLeadId(state),
    status: "",
    currentUrl: props.location?.pathname,
    staticContent: getLeadManageStaticContent(state),
    lead: getLeadDetails(state),
    logId: getLeadLogId(state),
    agent: getUserAgent(state),
    isLeadManageFromLeadList: getLeadManageParentPath(state),
    isUpdatingLead: getLeadUpdatingStatus(state),
    leadStatusList: getLeadStatusList(state),
    closedLostReasons: getLeadClosedLostReasons(state),
    isRejectingLead: getRejectingLeadStatus(state),
    leadLogs: getLeadLogs(state),
    venuebundlenotes: getVenueBundleNotes(state),
    isAddingVenueBundleNote: getAddingVenueBundleNote(state),
    isEditingVenueBundleNote: getEditingVenueBundleNote(state),
    partnerAccountObjectMap: getPartnerAccountObjectMap(state),
    partneraccount: getPartnerAccount(state),
    pageNum: getLeadPageNum(state),
    isFullViewTabvisible: getFullViewTabVisiblestate(state),
    activeVenue: getActiveVenue(state),
  };
}

BasicDetailPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  router: PropTypes.object,
};

export default connect(mapStateToProps)(withRoute(BasicDetailPage));
